<template>
  <component :is="sportMapping[model.params.sport]" :model="model" />
</template>

<script>
import NflLiveActivityTestToolView from '@/modules/integrations/types/sportradar/components/NflLiveActivityTestToolView'
import MlbLiveActivityTestToolView from '@/modules/integrations/types/sportradar/components/MlbLiveActivityTestToolView'

export default {
  name: 'LiveActivityTestTool',

  components: { NflLiveActivityTestToolView, MlbLiveActivityTestToolView },

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      sportMapping: {
        nfl: NflLiveActivityTestToolView,
        mlb: MlbLiveActivityTestToolView
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/types/sportradar/LiveActivityTestTool.vue